import $ from "jquery";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["eventHeader", "eventHeaderPanel", "eventHeaderButtonText"];

  connect() {}

  action() {
    if (this.eventHeaderTarget.classList.contains("is-open")) {
      this.eventHeaderTarget.classList.remove("is-open");
      $(this.eventHeaderPanelTarget).stop().slideUp();
      this.eventHeaderButtonTextTarget.textContent = "メニューを開く";
    } else {
      this.eventHeaderTarget.classList.add("is-open");
      $(this.eventHeaderPanelTarget).stop().slideDown();
      this.eventHeaderButtonTextTarget.textContent = "メニューを閉じる";
    }
  }
}
